import { blobticService } from '../../Commun/services/blobticService';

export enum MaterialType {
    Aluminum = 1,
    PVC = 2,
    Wood = 3,
    Steel = 4
}

export interface Material {
    id: number;
    uid?: string;
    code?: string;
    name: string;
    materialType: number;
    description?: string;
    unitPrice: number;
    unit: string;
    stockQuantity: number;
    isActive: boolean;
    lastUpdate?: Date;
}

interface MaterialDto {
    MAT_IDF: number;
    MAT_UIDF?: string;
    MAT_CODE?: string;
    MAT_LIB: string;
    MAT_TYPE: number;
    MAT_DESCRIPTION?: string;
    MAT_PRICE: number;
    MAT_UNIT: string;
    MAT_STOCK: number;
    MAT_ACTIVE: number; // 1 for true, 0 for false
    LAST_UPDT?: string;
}

const mapDtoToModel = (dto: MaterialDto): Material => ({
    id: dto.MAT_IDF,
    uid: dto.MAT_UIDF,
    code: dto.MAT_CODE,
    name: dto.MAT_LIB,
    materialType: dto.MAT_TYPE,
    description: dto.MAT_DESCRIPTION,
    unitPrice: dto.MAT_PRICE,
    unit: dto.MAT_UNIT,
    stockQuantity: dto.MAT_STOCK,
    isActive: dto.MAT_ACTIVE === 1,
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined,
});

const mapModelToDto = (model: Partial<Material>): Partial<MaterialDto> => ({
    MAT_IDF: model.id,
    MAT_UIDF: model.uid,
    MAT_CODE: model.code,
    MAT_LIB: model.name,
    MAT_TYPE: model.materialType,
    MAT_DESCRIPTION: model.description,
    MAT_PRICE: model.unitPrice,
    MAT_UNIT: model.unit,
    MAT_STOCK: model.stockQuantity,
    MAT_ACTIVE: model.isActive ? 1 : 0
});

export const materialsApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_material,Select'
            }
        });
        if (response.success && Array.isArray(response.data)) {
            return {
                data: response.data.map((item: any) => mapDtoToModel(item)),
                success: true
            };
        }
        return { data: [], success: false, message: response.message };
    },

    create: async (material: Material) => {
        const dto = mapModelToDto(material);
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_material,Insert',
                ...dto
            }
        });
        return {
            success: response.success,
            message: response.message
        };
    },

    update: async (id: number, material: Partial<Material>) => {
        const dto = mapModelToDto(material);
        dto.MAT_IDF = id;
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_material,Update',
                ...dto
            }
        });
        return {
            success: response.success,
            message: response.message
        };
    },

    delete: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_material,Delete',
                MAT_IDF: id
            }
        });
        return {
            success: response.success,
            message: response.message
        };
    }
};
